export default __webpack_public_path__ + "danger_info.898e7125.svg";